import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const VerifyTag = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/administracion-inventario/verificar/movimientos/split/etiquetas/master/hijas/${params.almacen}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        verifyTagMutation: mutation.mutate,
    };
}